import logger from '../utils/rbata.logger';

const trackingPromotion = {
    trackPromotionClick(dataset, href) {
        dataLayer.push({
            'event':             'EECmoduleClick',
            'availableElements': alphatauri.util.countComponents(`.${dataset.selector}`),
            'promotionmodule':   dataset.position,
            'ecommerce':         {
                'promoClick': {
                    'promotions': [{
                        'id':       dataset.id,
                        'name':     dataset.name,
                        'creative': undefined,
                        'position': undefined
                    }]
                }
            }
        });
        dataLayer.push({
            event:     'select_promotion',
            ecommerce: {
                'promotion_module':             dataset.position,
                'promotion_position_available': alphatauri.util.countComponents(`.${dataset.selector}`),
                items:                          [{
                    'promotion_id': dataset.id,
                    'promotion_name': dataset.name,
                    'creative_name': undefined,
                    'creative_slot': undefined,
                    'location_id': dataset.position
                }]
            },
            'eventCallback':     function () {
                document.location = href
            },
            'eventTimeout':      2000
        });
    },
    bindPromotionClick() {
        $(document.body).on('click', '.js-track-promotion', (evt) => {
            // https://www.simoahava.com/gtm-tips/use-eventtimeout-eventcallback/
            if (window['google_tag_manager']) {
                evt.preventDefault();
                this.trackPromotionClick(evt.currentTarget.dataset, evt.currentTarget.href);
            } else {
                logger.debug('no GTM present');
            }
        });
    }
};

$(() => {
    trackingPromotion.bindPromotionClick();
});

export default trackingPromotion;
